import {
  subscribeStatsActionBuilder,
  unsubscribeStatsActionBuilder,
  KV_LIVE_STATS_UNLEASH_FLAG,
  prefixTopic,
} from '@ahaslides-product/frontend-toolkit'
import { getKvSyncApi } from '@/api/kvSync'
import { liveStats } from '@/mqtt/liveStats'
import config from '@/config'
import liveStatsPollActions from './live-stats.poll.actions'
import liveStatsCountingActions from './live-stats.counting.actions'

const kvSyncApi = () => {
  return getKvSyncApi()
}

const actions = {
  fetchStatsByKeyAction: async ({ commit, getters, rootGetters }, { statsKeys }) => {
    if (!rootGetters[KV_LIVE_STATS_UNLEASH_FLAG]) return
    if (!statsKeys || statsKeys.length === 0) return
    const statsRequests = statsKeys.map((statsKey) => {
      return kvSyncApi().getValueByKey(prefixTopic(`/${getters.liveStatsVersionPrefix}/${config.livestatsTopicPrefix}/`, statsKey))
        .then((response) => response.body)
    })
    const results = await Promise.allSettled(statsRequests)
    results.forEach((result, index) => {
      if (result.status !== 'fulfilled' || !result.value) return
      const { key, value } = result.value
      if (!key || value == null) return
      commit('updateStats', { topic: statsKeys[index], message: value })
    })
  },
  fetchStatsByWildCardAction: async ({ commit, getters }, { path }) => {
    if (!path) return
    const resp = await kvSyncApi().getValuesByPath(prefixTopic(`/${getters.liveStatsVersionPrefix}/${config.livestatsTopicPrefix}/`, path))
    const keyValuePairs = resp.body && resp.body.keysvalues
    if (!keyValuePairs || keyValuePairs.length == 0) return
    keyValuePairs.forEach(({ key, value }) => {
      const topicWithoutPrefix = key.replace(`/${getters.liveStatsVersionPrefix}/${config.livestatsTopicPrefix}/`, '')
      commit('updateStats', { topic: decodeURIComponent(topicWithoutPrefix), message: value })
    })
  },
  subscribeStatsAction: subscribeStatsActionBuilder(liveStats),
  unsubscribeStatsAction: unsubscribeStatsActionBuilder(liveStats),

  ...liveStatsPollActions,
  ...liveStatsCountingActions,
}

export default actions
